import { useState, useRef } from "react";
import "../styles/EventsGallery.css";

const eventsData = [
    {
        title: "பொங்கல் மற்றும் தமிழர் திருநாள், இளம்பிள்ளை நகர பாஜக",
        images: [
            "/assets/pongalcele/1.jpeg",
            "/assets/pongalcele/2.jpeg",
            "/assets/pongalcele/3.jpeg",
            "/assets/pongalcele/4.jpeg",
            "/assets/pongalcele/5.jpeg",
            "/assets/pongalcele/6.jpeg",
            "/assets/pongalcele/7.jpeg",
            "/assets/pongalcele/8.jpeg",
            "/assets/pongalcele/9.jpeg",
            "/assets/pongalcele/10.jpeg",
            "/assets/pongalcele/11.jpeg",
            "/assets/pongalcele/12.jpeg",
            "/assets/pongalcele/13.jpeg",
            "/assets/pongalcele/14.jpeg",
            "/assets/pongalcele/15.jpeg",
            "/assets/pongalcele/16.jpeg",
            "/assets/pongalcele/17.jpeg",
        ],
    },
    {
        title: "பூத் கமிட்டி மாநாடு மற்றும் பயிலரங்கம் ",
        images: [
            "/assets/booth/1.jpeg",
            "/assets/booth/2.jpeg",
            "/assets/booth/3.jpeg",
            "/assets/booth/4.jpeg",
            "/assets/booth/5.jpeg",
            "/assets/booth/6.jpeg",
            "/assets/booth/7.jpeg",
            "/assets/booth/8.jpeg",
            "/assets/booth/9.jpeg",
            "/assets/booth/10.jpeg",
            "/assets/booth/11.jpeg",
            "/assets/booth/12.jpeg",
            "/assets/booth/13.jpeg",
            "/assets/booth/14.jpeg",
            "/assets/booth/15.jpeg",
        ],
    },
    {
        title: "ஒன்றிய மகளிர் நிர்வாகி பொறுப்புகளுக்கு தேர்வு செய்யப்பட்ட பொழுது இந்த தருணம்",
        images: [
            "/assets/onriya/1.jpeg",
            "/assets/onriya/2.jpeg",
            "/assets/onriya/3.jpeg",
            "/assets/onriya/4.jpeg",
        ],
    },
    {
        title: "சேலம் கிழக்கு மாவட்டம் வீரபாண்டி வடக்கு ஒன்றியம்",
        descrip: "சேலம் கிழக்கு மாவட்டம் வீரபாண்டி வடக்கு ஒன்றியம் பெரிய சீரகாபாடி புதிதாக நமது பாரதிய ஜனதா கட்சியில் உறுப்பினர் சேர்க்கையில் நமது கிழக்கு மாவட்ட விவசாய அணி பொதுச்செயலாளர் சி வெங்கடேசன் கிழக்கு மாவட்ட மகளிர் அணி துணை தலைவர் அக்கா சுதா தலைமையில் ஒன்றிய தலைவி விஜய தலைமையில் வீரபாண்டி ஒன்றிய தலைவர் இ பழனிசாமி தலைமையில் கட்சியில் இணைக்கப்பட்ட தருணம்",
        images: [
            "/assets/veerapandi/1.jpeg",
            "/assets/veerapandi/2.jpeg",
            "/assets/veerapandi/3.jpeg",
            "/assets/veerapandi/4.jpeg",
            "/assets/veerapandi/5.jpeg",
            "/assets/veerapandi/6.jpeg",
            "/assets/veerapandi/7.jpeg",
            "/assets/veerapandi/8.jpeg",
            "/assets/veerapandi/9.jpeg",
            "/assets/veerapandi/10.jpeg",
        ],
    }
];

const EventsGallery = () => {
    const [activeImage, setActiveImage] = useState({
        eventIndex: null,
        imageIndex: null,
    });

    const sliderRef = useRef(null);

    return (
        <div className="eg">
            <h1>நிகழ்வுகள் தொகுப்பு</h1>
            <div className="events-containereve">
                {eventsData.map((event, index) => (
                    <div className="event-sectioneve" key={index}>
                        {/* Event Title */}
                        <h2 className="event-titleeve">{event.title} :-</h2>
                        <p className="event-deseve">
                            {event.descrip}
                        </p>

                        {/* Event Images */}
                        <div className="event-imageseve">
                            {event.images.map((img, i) => (
                                <div className="image-cardeve" key={i} onClick={() =>
                                    setActiveImage({ eventIndex: index, imageIndex: i })
                                }
                                >
                                    <img src={img} alt={`${event.title} ${i + 1}`} />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            {activeImage.eventIndex !== null && (
                <div className="fullscreen" onClick={() => setActiveImage({ eventIndex: null, imageIndex: null })}>
                    <span className="close">×</span>

                    <div
                        className="fullscreen-slider"
                        ref={sliderRef}
                        onClick={(e) => e.stopPropagation()}
                        onTouchStart={(e) =>
                            (sliderRef.current.startX = e.touches[0].clientX)
                        }
                        onTouchEnd={(e) => {
                            const diff =
                                sliderRef.current.startX - e.changedTouches[0].clientX;

                            const images =
                                eventsData[activeImage.eventIndex].images;

                            if (diff > 50 && activeImage.imageIndex < images.length - 1) {
                                setActiveImage({
                                    ...activeImage,
                                    imageIndex: activeImage.imageIndex + 1,
                                });
                            }

                            if (diff < -50 && activeImage.imageIndex > 0) {
                                setActiveImage({
                                    ...activeImage,
                                    imageIndex: activeImage.imageIndex - 1,
                                });
                            }
                        }}
                    >
                        <img
                            src={
                                eventsData[activeImage.eventIndex]
                                    .images[activeImage.imageIndex]
                            }
                            alt="fullscreen"
                        />
                    </div>
                </div>
            )}

        </div>
    );
};

export default EventsGallery;
